import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import service1 from '../assets/service1.jpg';
import service2 from '../assets/service2.jpg';
import service3 from '../assets/service3.jpg';
import service4 from '../assets/service4.jpg';
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    img: service1,
    title: "Personal Loans",
    desc: "Achieve your goals with easy, flexible personal loans designed for men/women. Quick approval, minimal documentation, and convenient repayment options."
  },
  {
    img: service2,
    title: "Loan Against Property",
    desc: "Unlock the value of your property with our easy Loan Against Property. Get higher loan amounts, flexible tenure, and competitive interest rates to meet your financial needs."
  },
  {
    img: service3,
    title: "Business Loans",
    desc: "Fuel your business growth with easy loans designed for entrepreneurs. Quick approval, flexible repayment, and support to expand or start your venture."
  },
  {
    img: service4,
    title: "Housing & Consumer Loans",
    desc: "Make your dream home or purchase a big-ticket item with our easy housing and consumer loans. Flexible terms, quick approval, and tailored for men/women’s financial needs."
  }
];

const OurServices = () => {

  const navigate = useNavigate();

  return (
    <section className="py-5 services-section">
      <div className="container">
        {/* Section Title */}
        <div className="text-center mb-5">
          <h6 className="text-uppercase text-primary fw-bold mb-3">
            OUR SERVICES
          </h6>
          <h1 className="fw-bold display-6 services-title raleway">
            Empowering Women with Tailored Loans and Financial Solutions for Every Need
          </h1>
        </div>

        {/* Services Grid */}
        <div className="row g-4">
          {servicesData.map((service, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-6">
              <div className="service-card shadow-sm rounded-4 overflow-hidden hover-card">
                <img src={service.img} alt={service.title} className="img-fluid w-100 service-img" />
                <div className="p-4 service-info light-bg">
                  <h3 className="fw-bold mb-3">{service.title}</h3>
                  <p className="mb-0">{service.desc}</p>
                  <div className="text-center mt-4">
                    <button className="btn btn-info" onClick={() => navigate('/contact')}>Enquiry</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
